import React, { useState } from "react";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';
import CloseButton from 'react-bootstrap/CloseButton';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { FaKey, FaUsers, FaShieldAlt, FaCalendarAlt } from 'react-icons/fa';

import XAccess from "../components/XAccess";
import XMembersLight from "../components/XMembersLight";
import IncidentZ from "../components/Incidentz";
import puzzle from "../images/puzzle.png";
import BannedListAdminLight from "../components/BannedListAdminLight";

export default function Admin(props) {
    const [showCanvas, setShowCanvas] = useState(false);

    // Track which child component view is explicitly open/clicked within a tab
    const [activeChild, setActiveChild] = useState(null);

    // Controlled top-level active tab selection state - initialized to "access" to load instantly
    const [activeTab, setActiveTab] = useState("access");

    const handleOpenCanvas = () => {
        setShowCanvas(true);
        setActiveTab("access"); // Ensure "access" is the active view every time it opens
        setActiveChild(null);   // Ensure scanner requires an explicit user tap
    };

    const handleCloseCanvas = () => {
        setShowCanvas(false);
        setActiveTab("access");  // Reset to default tab state safely
        setActiveChild(null);
    };

    // Helper to toggle internal child views cleanly
    const toggleChildView = (viewName) => {
        setActiveChild(prev => prev === viewName ? null : viewName);
    };

    // Handles changing tabs and safely clearing child state so screens do not bleed over
    const handleTabSelect = (tabKey) => {
        setActiveTab(tabKey);
        setActiveChild(null);
    };

    return (
        <>
            <Button onClick={handleOpenCanvas}>
                <img
                    src={puzzle}
                    alt="Bar Admin"
                    className="thumb hoverX animated fadeInRight"
                />  <br />
                <span>Bar Staff</span>
            </Button>

            <Offcanvas show={showCanvas} onHide={handleCloseCanvas} backdropClassName="adminBackdrop" placement="top" className="bg-dark">
                <Offcanvas.Header className="pb-2 border-bottom border-opacity-10">
                    <div className="w-100">
                        {/* Title Bar Row */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className="modified xTitle animated rollIn m-0">
                                Admin
                            </h3>
                            <CloseButton
                                variant="white"
                                onClick={handleCloseCanvas}
                                className="m-0 p-1"
                            />
                        </div>

                        {/* RESPONSIVE MASTER TABS */}
                        <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                            <Nav variant="pills" className="flex-column flex-sm-row gap-2 mb-1 profile-nav-dark">
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="access" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaKey size={14} /> Access
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="members" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaUsers size={14} /> Members
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="banned" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaShieldAlt size={14} /> Banned List
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item className="flex-fill">
                                    <Nav.Link eventKey="events" className="text-center py-2 d-flex align-items-center justify-content-center gap-2">
                                        <FaCalendarAlt size={14} /> Events
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Tab.Container>
                    </div>
                </Offcanvas.Header>

                <Offcanvas.Body className="padding squiggleX">
                    <Tab.Container activeKey={activeTab}>
                        <Tab.Content>

                            {/* --- ACCESS TAB PANEL --- */}
                            <Tab.Pane eventKey="access">
                                <strong>Access Control Portal</strong><br /><br />

                                <div className="arrow_box_top p-3">
                                    <div className="admin-grid-container">
                                        <div className="glass-tile">
                                            <XAccess
                                                isOpen={activeChild === 'access'}
                                                onToggle={() => toggleChildView('access')}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <br />

                                <div className="p-3 bg-dark-profile rounded border border-info border-opacity-25 animated fadeIn">
                                    {/* Operational instructions for checking in patrons */}
                                    <div className="mb-3 text-warning small opacity-75">
                                        <p className="mb-2">⚠️ <strong>Mandatory Staff Protocol:</strong> Verify all individuals upon arrival regardless of whether you know them personally. Keeping accurate, real-time track of club attendance is strictly mandatory for capacity management and legal compliance.</p>
                                    </div>

                                    <div className="text-white-50" style={{ fontSize: '13px' }}>
                                        <p className="mb-2">
                                            • Patrons may present digital proof of check-in via smartphone <strong>Geolocation tracking</strong>, which is fully accepted.
                                        </p>
                                        <p className="mb-2">
                                            • Ensure you explicitly <strong>verify if they have checked in any accompanying guests</strong>.
                                        </p>
                                        <p className="mb-2">
                                            • If Geolocation validation fails, request the patron navigate to their profile screen to present their <strong>personal membership QR Code</strong> for local scanner validation.
                                        </p>
                                        <p className="m-0">
                                            • If digital credentials are unavailable, you may physically scan a <strong>manual physical club card</strong> or execute a direct search using the patron's legal name or primary email address.
                                        </p>
                                    </div>
                                </div>
                                <br />
                            </Tab.Pane>

                            {/* --- MEMBERS TAB PANEL --- */}
                            <Tab.Pane eventKey="members">
                                <strong>Member Verification Console</strong><br /><br />

                                <div className="arrow_box_top p-3">
                                    <div className="admin-grid-container">
                                        <div className="glass-tile">
                                            <XMembersLight
                                                theme={"dark"}
                                                isOpen={activeChild === 'members'}
                                                onToggle={() => toggleChildView('members')}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br />

                                {/* Operational instructions for looking up accounts and processing fees manually */}
                                <div className="mb-3 text-white-50 small animated fadeIn">
                                    <p className="mb-3">Use this console window to look up existing member profiles, log behavioral incident reports, audit account criteria, and view or print custom club QR codes.</p>
                                    <div className="p-3 bg-dark-profile rounded border border-info border-opacity-25">
                                        <p className="m-0 text-info fw-bold" style={{ fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                            ℹ️ Manual Payment Processing Rules
                                        </p>
                                        <p className="mt-2 mb-0 text-white-50" style={{ fontSize: '13px' }}>
                                            Record manual membership overrides here <strong>ONLY</strong> if the individual is paying in person with physical cash, or if the integrated Stripe credit card processor is offline. You may also proceed with manual entry if the user opts out of processing their membership renewal directly through the application.
                                            <span className="text-warning d-block mt-2 fw-bold">CRITICAL: You must always document the exact cash register transaction number or paper receipt reference within the payment notes field.</span>
                                        </p>
                                    </div>
                                </div>
                                <br />
                            </Tab.Pane>

                            {/* --- BANNED LIST TAB PANEL --- */}
                            <Tab.Pane eventKey="banned">
                                <strong>Global Banned Registry</strong><br /><br />
                                <div className="arrow_box_top p-3">
                                    <BannedListAdminLight
                                        theme={"dark"}
                                        isOpen={activeChild === 'banned'}
                                        onToggle={() => toggleChildView('banned')}
                                    />
                                </div>
                            </Tab.Pane>

                            {/* --- EVENTS TAB PANEL --- */}
                            <Tab.Pane eventKey="events">
                                <strong>Events Panel</strong><br /><br />
                                <div className="arrow_box_top p-3">
                                    <span className="text-muted small">Event management view coming soon...</span>
                                </div>
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}